module.exports = __webpack_public_path__ + "static/media/Artboard9.0d6ed044.png";